import { Action } from '../actions/nearby';

const defaultState = {
  isFetching: false,
  stationsById: {},
  error: undefined,
};

export default function nearbyReducer(state = defaultState, action) {
  const body = action?.payload;

  switch (action?.type) {
    case Action.Nearby.NearbyCompleted:
      return {
        isFetching: false,
        stationsById: {
          ...state.stationsById,
          [body.station_id]: body.stations.map(s => s.id),
        },
      };

    case Action.Nearby.NearbyFailed:
      return {
        ...state,
        isFetching: false,
        error: body,
      };

    case Action.Nearby.NearbyPending:
      return {
        ...state,
        error: undefined,
        isFetching: true,
      };

    default:
      return state;
  }
}
